export const AB_TEST: Record<string, string> = {
  HIDE_REVIEWS_AB_TEST_NUMBER: '79',
  FEATURE_ENABLED_VALUE: '1',
};
